export default __webpack_public_path__ + "static/media/ln_en.56af3c70.jpg";